// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import {
    ModalTrigger, ModalEditarUsuario, ModalBloquearUsuario,
    ModalCambiarContrasena, ModalHistorial, ModalBloquearCliente,
    ModalUploadFiles, ModalReviewFiles, ModalApproveFiles, ModalDesbloquearUsuario
} from './Modales.jsx'
import { HeaderConBusqueda } from '../../components/shared/HeaderConBusqueda.jsx'
// Styles
import * as css from './tablaPersonal.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class TablaPersonal extends React.Component {
    render(){
        return (
            <div style={{height: '100%'}}>
                <AutoSizer>
                    {({ height, width }) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.usuarios.length}
                            rowGetter={({index})=> this.props.usuarios[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                        >
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({rowIndex}) => rowIndex+1}
                                width={25}
                            />
                            <Column
                                dataKey='RUN'
                                label={'RUN'}
                                cellRenderer={({ rowData, dataKey }) => rowData[dataKey]}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="RUN"
                                        busqueda={this.props.busquedaRUN}
                                        realizarBusqueda={this.props.realizarBusquedaRUN}
                                    />
                                }
                                width={70}
                            />
                            <Column
                                dataKey='nombres'
                                label={'nombres'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="Nombres"
                                        busqueda={this.props.busquedaNombre}
                                        realizarBusqueda={this.props.realizarBusquedaNombre}
                                    />
                                }
                                cellRenderer={({ rowData }) =>
                                    <div>
                                        <p style={{margin: 0}}>{rowData.nombre1}</p>
                                        <p style={{margin: 0}}>{rowData.nombre2}</p>
                                    </div>
                                }
                                width={130}
                            />
                            <Column
                                dataKey='apellidos'
                                label={'Apellidos'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="Apellidos"
                                        busqueda={this.props.busquedaApellido}
                                        realizarBusqueda={this.props.realizarBusquedaApellido}
                                    />
                                }
                                cellRenderer={({ rowData }) =>
                                    <div>
                                        <p style={{margin: 0}}>{rowData.apellidoPaterno}</p>
                                        <p style={{margin: 0}}>{rowData.apellidoMaterno}</p>
                                    </div>
                                }
                                width={130}
                            />
                            <Column
                                dataKey='comuna'
                                label={'Comuna'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="Comunas"
                                        busqueda={this.props.busquedaComuna}
                                        realizarBusqueda={this.props.realizarBusquedaComuna}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={90}
                            />
                            <Column
                                dataKey='captador'
                                label={'Captador'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="Captador"
                                        busqueda={this.props.busquedaCaptador}
                                        realizarBusqueda={this.props.realizarBusquedaCaptador}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={100}
                            />
                            <Column
                                dataKey='vigencia'
                                label={'Vigencia'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre = "Vigencia"
                                        busqueda = {this.props.busquedaVigencia}
                                        realizarBusqueda = {this.props.realizarBusquedaVigencia}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={85}
                            />
                            <Column
                                dataKey='bloqueado'
                                label={'bloqueo'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]? 'Bloqueado' : ''}
                                width={90}
                            />
                            <Column
                                dataKey='isContractFile'
                                label={'Contrato'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre = "Contrato"
                                        busqueda = {this.props.seachStatusContract}
                                        realizarBusqueda = {this.props.searchingStatusContract}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={100}
                            />
                            <Column
                                dataKey=''
                                label={''}
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                    <div>
                                        {/* Editar */}
                                        <BotonEditar
                                            datosbancos = {this.props.datosbancos}
                                            usuario = {rowData}
                                            comunas = {this.props.comunas}
                                            fetchUsuarios = {this.props.fetchUsuarios}
                                            //actualizarUsuario={this.props.actualizarUsuario.bind(rowData.id)}
                                        />
                                        {/* Bloquear */}
                                        <BotonBloquear
                                            idUsuario = {rowData.id}
                                            estaBloqueado = {rowData.bloqueado}
                                            bloquearUsuario = {this.props.bloquearUsuario}
                                            desbloquearUsuario = {this.props.desbloquearUsuario}
                                        />
                                        {/* Bloqueo por cliente */}
                                        <BotonBloquearCliente
                                            usuario = {rowData}
                                            bloquearUsuarioCliente = {this.props.bloquearUsuarioCliente.bind(rowData.id)}
                                            clientes = {this.props.clientes}
                                        />
                                        {/* Cambiar contraseña */}
                                        <BotonCambiarContrasena
                                            idUsuario = {rowData.id}
                                            cambiarContrasena = {this.props.cambiarContrasena}
                                        />
                                        {/* Historial nomina */}
                                        <BotonVerHistorial
                                            idUsuario = {rowData.id}
                                            verHistorial = {this.props.verHistorial.bind(this, rowData.id)}
                                        />
                                        {/* Documentos usuarios */}
                                        <ButtonUploadFiles
                                            user = {rowData}
                                            idUsuario = {rowData.id}
                                            statusFiles = {rowData.statusFiles}
                                        />
                                        <ButtonDownloadFiles
                                            idUsuario = {rowData.id}
                                        />
                                        <ButtonReviewFiles
                                            user = {rowData}
                                            statusFiles = {rowData.statusFiles}
                                            canApproveFiles = {this.props.perms.canApproveFiles}
                                        />
                                        <ButtonApproveFiles
                                            idUser = {rowData.id}
                                            statusFiles = {rowData.statusFiles}
                                            onApproveFiles = {this.props.onApproveFiles}
                                            canApproveFiles = {this.props.perms.canApproveFiles}
                                        />
                                    </div>
                                )}
                                width={360}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}
TablaPersonal.propTypes = {
    usuarios: PropTypes.arrayOf(PropTypes.object).isRequired,
    // Metodos
    bloquearUsuario: PropTypes.func.isRequired,
    desbloquearUsuario: PropTypes.func.isRequired,
    onApproveFiles: PropTypes.func.isRequired,
    cambiarContrasena: PropTypes.func.isRequired,
    fetchUsuarios: PropTypes.func.isRequired
}

const BotonEditar = ({usuario, comunas, fetchUsuarios, datosbancos})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary" onClick={showModal} title="Editar datos de operador">
                <span className={'glyphicon glyphicon-edit'}></span>
                {isVisible && <ModalEditarUsuario
                    usuario={usuario}
                    comunas={comunas}
                    hideModal={hideModal}
                    fetchUsuarios={fetchUsuarios}
                    datosbancos = {datosbancos}
                />}
            </button>
        }
    </ModalTrigger>
    
const BotonBloquearCliente = ({usuario, bloquearUsuarioCliente, clientes})=>
        <ModalTrigger>
            {(isVisible, showModal, hideModal)=>
                <button className="btn btn-md btn-primary" onClick={showModal} title="Bloqueo de operador por cliente">
                    <span className={'glyphicon glyphicon-remove'}></span>
                    {isVisible && <ModalBloquearCliente
                        usuario={usuario}
                        bloquearUsuarioCliente={bloquearUsuarioCliente}
                        clientes={clientes}
                        hideModal={hideModal}
                    />}
                </button>
            }
        </ModalTrigger>

const BotonBloquear = ({idUsuario, estaBloqueado, bloquearUsuario, desbloquearUsuario})=>
    estaBloqueado==false?
        <ModalTrigger>
            {(isVisible, showModal, hideModal)=>
                <button className="btn btn-md btn-success" onClick={showModal} title="Bloquear operador">
                    <span className={'glyphicon glyphicon-ban-circle'}></span>
                    {isVisible && (
                        <ModalBloquearUsuario
                            hideModal={hideModal}
                            onBloquear={()=>{
                                hideModal()
                                bloquearUsuario(idUsuario)
                            }}
                        />
                    )}
                </button>
            }
        </ModalTrigger>
    :
        <ModalTrigger>
            {(isVisible, showModal, hideModal)=>
                <button className="btn btn-md btn-danger" onClick={showModal} title="Desbloquear operador">
                    <span className={'glyphicon glyphicon-ban-circle'}></span>
                    {isVisible && (
                        <ModalDesbloquearUsuario
                            hideModal={hideModal}
                            onDesbloquear={()=>{
                                hideModal()
                                desbloquearUsuario(idUsuario)
                            }}
                        />
                    )}
                </button>
            }
        </ModalTrigger>

const BotonCambiarContrasena = ({idUsuario, cambiarContrasena})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary" onClick={showModal} title="Cambiar contraseña de usuario">
                <span className={'glyphicon glyphicon-lock'}></span>
                {isVisible && (
                    <ModalCambiarContrasena
                        hideModal={hideModal}
                        onAceptar={(contrasena)=>{
                            hideModal()
                            cambiarContrasena(idUsuario, contrasena)
                        }}
                    />
                )}
            </button>
        }
    </ModalTrigger>

const ButtonReviewFiles = ({user, statusFiles, canApproveFiles}) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary" onClick={showModal} title="Revisar documentación de usuario">
                <span className={'glyphicon glyphicon-eye-open'}></span>
                {isVisible && (
                    <ModalReviewFiles
                        hideModal = {hideModal}
                        user = {user}
                        statusFiles = {statusFiles}
                        canApproveFiles = {canApproveFiles}
                    />
                )}
            </button>
        }
    </ModalTrigger>

const BotonVerHistorial = ({idUsuario, verHistorial})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary" onClick={showModal} title="Historial inventarios de operador">
                <span className={'glyphicon glyphicon-stats'}></span>
                {isVisible && (
                    <ModalHistorial
                        hideModal={hideModal}
                        verHistorial={verHistorial}
                    />
                )}
            </button>
        }
    </ModalTrigger>

const ButtonUploadFiles = ({user, idUsuario, statusFiles}) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary" onClick={showModal} title="Subir documentos de operador" disabled={statusFiles==='Aprobados'}>
                <span className={'glyphicon glyphicon-upload'}></span>
                {isVisible && (
                    <ModalUploadFiles
                        hideModal={hideModal}
                        user = {user}
                        idUsuario = {idUsuario}
                        statusFiles = {statusFiles}
                    />
                )}
            </button>
        }
    </ModalTrigger>

const ButtonDownloadFiles = ({idUsuario}) =>
    <a className="btn btn-md btn-primary" title="Descargar documentos de operador"
        href={`/api/usuario/${idUsuario}/download/personal-files`}>
        <span className={'glyphicon glyphicon-download'}></span>
    </a>

const ButtonApproveFiles = ({idUser, statusFiles, onApproveFiles, canApproveFiles}) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className={statusFiles === 'Aprobados' ? 'btn btn-md btn-success' : 'btn btn-md btn-warning'} onClick={showModal} title="Aprobar revisión de documentos" disabled={!canApproveFiles}>
                <span className={statusFiles === 'Aprobados' ? 'glyphicon glyphicon-ok-sign' : 'glyphicon glyphicon-hourglass'}></span>
                {isVisible && (
                    <ModalApproveFiles
                        hideModal={hideModal}
                        statusFiles={statusFiles}
                        onApproveFiles = {() => {
                        hideModal()
                        onApproveFiles(idUser, statusFiles === 'Aprobados'? 3: 4)
                    
                }}
                    />
                )}
            </button>
        }
    </ModalTrigger>


// WEBPACK FOOTER //
// ./frontEnd/admin/MantenedorPersonal/TablaPersonal.jsx